import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useWeb3React } from '@web3-react/core';
import { useEffect } from 'react';
import { useState } from 'react';
import { ABI, ABINotarize, API_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid, Notarizematicaddress } from '../../Config';
import swal from 'sweetalert';  
import Loading from '../../Components/loader/loader';
import axios from 'axios';
import { useCheckChain } from '../../Hooks/useCheckChain';
import { useHistory } from 'react-router-dom';
import bnb from '../../images/bnb.png'
import eth from '../../images/eth.png'
import matic from '../../images/matic.png'



/* global BigInt */
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function NestedModal(props) {
    const { account, library, chainId } = useWeb3React();
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState(0);
    const [balance, setbalance] = useState("");
    const [isloading, setisloading] = useState(false);
    const { switchChain } = useCheckChain();
    const redirect = useHistory();
    const [Usdvalue,setprice]=useState("");

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getbalance = async () => {
        if (library) {
            const Web3 = require('web3');
            const web3 = new Web3(library.provider);
            // if (props.prop?.data?.NFT_info?.NFT_payment == "BNB" || props.prop?.data?.NFT_info?.NFT_payment == "MATIC"|| props.prop?.data?.NFT_info?.NFT_payment == "ETH") {
                web3.eth.getBalance(account).then((result) => {
                    setbalance(result / 10 ** 18);
                });
            // } else {
            //     const Web3 = require('web3');
            //     const web3 = new Web3(library.provider);
            //     let paymentcurrency = props.prop?.data?.NFT_info?.PaymentCurrency;
            //     let Tokencontract = await new web3.eth.Contract(tokenabi, paymentcurrency);
            //     Tokencontract.methods.balanceOf(account).call().then((result) => {
            //         setbalance(result / 10 ** 18);
            //     })
            // }

        }
    }

    useEffect(() => {
        if (props.prop?.data) {
            if (props.prop?.data?.NFT_info?.NFT_chainid == Bsc_Chainid) {
                if (chainId === Matic_Chainid ||chainId === ETH_Chainid) {
                    switchChain(Bsc_Chainid);
                }
            } else if (props.prop?.data?.NFT_info?.NFT_chainid == Matic_Chainid) {
                if (chainId === Bsc_Chainid || chainId === ETH_Chainid) {
                    switchChain(Matic_Chainid);
                }
            } else if (props.prop?.data?.NFT_info?.NFT_chainid == ETH_Chainid) {
                if (chainId === Matic_Chainid || chainId === Bsc_Chainid) {
                    switchChain(ETH_Chainid);
                }
            }
        }

    }, [props.prop?.data])

    const Buynft = async () => {
        handleClose();
        if (library) {
            if (Number(props.prop?.data?.NFT_info?.NFT_chainid) == Number(chainId)) {

                if (props.prop?.data) {
                    if (props.prop?.data?.NFT_info?.NFT_chainid == chainId) {

                      
                        let price = props.prop?.data?.NFT_info?.NFT_price;
                        if(price>0){
                        setisloading(true)
                        let tokenId = props.prop?.data?.NFT_info?.NFT_id;
                        let owneradd = props.prop?.data?.NFT_info?.NFT_owner_address;
                        let image = props.prop?.data?.NFT_info?.NFT_image;
                        let name = props.prop?.data?.NFT_info?.NFT_name;
                        let collection_name = props.prop?.data?.NFT_info?.NFT_collection;
                        let currency = props.prop?.data?.NFT_info?.NFT_payment;
                        let Nftchainid = props.prop?.data?.NFT_info?.NFT_chainid;
                        let Paymentcurrency = props.prop?.data?.NFT_info?.PaymentCurrency;
                        let ismembernft = props.prop?.data?.NFT_info?.Membernft;
                        let tokens=props.prop?.data?.NFT_info?.Tokens;
                        let TokenName=props.prop?.data?.NFT_info?.TokenName;
                        let Notarize =props.prop?.data?.NFT_info?.Notarize;
                        let contract_address='';
                        let abi ='';
                        let amount;
                        let totalvalue;
                       
                        if (Nftchainid == Bsc_Chainid) {
                            if(Notarize==1){
                                // contract_address = bsccontractaddress
                                abi =ABINotarize;
                            }else{
                                contract_address = bsccontractaddress
                                abi = ABI;
                            }
                         
                        } else if (Nftchainid == Matic_Chainid) {
                            if(Notarize==1){
                                contract_address = Notarizematicaddress;
                                abi = ABINotarize;
                            }else{
                                contract_address = maticcontractaddress;   
                                abi = ABI;
                            }
                        
                        } else if(Nftchainid == ETH_Chainid){
                            if(Notarize==1){
                                // contract_address = Notarizematicaddress;
                                abi =ABINotarize;
                            }else{
                                contract_address = ethcontractaddress;
                                abi =ABI; 
                            }
                  
                        }
                        const Web3 = require('web3');
                        const web3 = new Web3(library.provider);
                        const contract = await new web3.eth.Contract(abi, contract_address);
                        let value = web3.utils.toWei(price.toString(), "ether");
                        if (ismembernft== 0) {
                            amount = 0;
                            totalvalue = value;
                            console.log(tokenId ,contract_address);

                            await contract.methods.transferNFT(tokenId, amount).estimateGas({
                                from: account.toString(),
                                value: totalvalue
                            })

                            await contract.methods.transferNFT(tokenId, amount).send({
                                from: account.toString(),
                                value: totalvalue
                            }).then(() => {
                                update(price, tokenId, owneradd, image, name, collection_name, currency,tokens,TokenName);
                                swal({
                                    title: "Success",
                                    text: "Congratulations! You bought the  NFT",
                                    icon: "success",
                                    allowOutsideClick: false,
                                    confirmButtonText: 'ok',
                                    confirmButtonColor: '#2dbe60',
                                }).then(() => {
                                    redirect.push('../Myitem')
                                })
                                setisloading(false)
                            }).catch(() => {
                                setisloading(false);
                            })
                        } else if(ismembernft==1){
                            amount = value;
                            
                                await contract.methods.buymembernft(tokenId).estimateGas({
                                    from: account.toString(),
                                    value: amount
                                })

                                await contract.methods.buymembernft(tokenId).send({
                                    from: account.toString(),
                                    value: amount
                                }).then(() => {
                                    update(price, tokenId, owneradd, image, name, collection_name, currency,tokens,TokenName);
                                    swal({
                                        title: "Success",
                                        text: "Congratulations! You bought the  NFT",
                                        icon: "success",
                                        allowOutsideClick: false,
                                        confirmButtonText: 'ok',
                                        confirmButtonColor: '#2dbe60',
                                    }).then(() => {
                                        redirect.push('../Myitem')
                                    })

                                    setisloading(false)
                                }).catch(() => {
                                    setisloading(false);
                                })
                       }
                    }else{
                        swal({
                            title: "Warning",
                            text: "Price Should be greater than 0",
                            icon: "error",
                            allowOutsideClick: false,
                            confirmButtonText: 'ok',
                            confirmButtonColor: '#2dbe60',
                        })
                    }
                    } else {
                        switchChain(props.prop?.data?.NFT_info?.NFT_chainid);
                    }
                }
            } else {
                switchChain(Number(props.prop?.data?.NFT_info?.NFT_chainid));
            }
        }
    }

    const update = async (price, tokenId, owneradd, image, name, collection_name, currency,Tokens,TokenName) => {

        var data = new FormData();
        data.append("value", price);
        data.append("buyerAddress", account);
        data.append("sellerAddress", owneradd);
        data.append("NFT_image", image);
        data.append("NFT_name", name);
        data.append("resell", "off");
        data.append("tokenid", tokenId);
        data.append("collection", collection_name);
        data.append("currency", currency);
        data.append("Token",Tokens);
        data.append("TokenName",TokenName);

        await axios
            .post(`${API_URL}/buy.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data; boundary=<calculated when request is sent>",
                },
            })

    };

    useEffect(() => {
        if (props.prop?.data?.NFT_info?.PaymentCurrency) {
            getbalance();
        }

    }, [library, props.prop?.data?.NFT_info?.PaymentCurrency, account])

    const paywithcrypto = async (value) => {
        var data = new URLSearchParams()
        data.append("client_id", 'oacid-clcekabzbqu3vktisbo7p0k6k')
        data.append("grant_type", 'client_credentials')
        data.append("client_secret", '1edd95abef81e84e3c1f2cd10696bff116f563696618bc229a8a526ed8bc2096')
        let res = await fetch(`https://api.triple-a.io/api/v2/oauth/token`, {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        let response = await res.json();
        if (response.access_token) {
            var datas = new URLSearchParams()
            datas.append("type", 'widget')
            datas.append("merchant_key", 'mkey-clcekabz6qu3uktis2s6g679n')
            datas.append("order_currency", 'USD')
            datas.append("order_amount", value)
            datas.append("payer_id", '483490639429')
            datas.append("payer_name", 'Steven Chan')
            datas.append("payer_email", 'steven.chan@triple-a.io')
            datas.append("success_url", 'https://duckduckgo.com')
            datas.append("cancel_url", 'https://yahoo.com')
            datas.append("notify_url", 'https://webhook.site/73219945-9656-4324-bce5-a574c1816e64')
            datas.append("notify_secret", 'Herro123!@#')
            datas.append("notify_txs", 'Herro123!@#')
            datas.append("webhook_data", JSON.stringify({
                "order_id": "ABC12345-2"
            }))
            datas.append("sandbox", true)

            let res = await fetch(`https://api.triple-a.io/api/v2/payment`, {
                method: 'POST',
                body: datas,
                headers: {
                    'Authorization': 'Bearer ' + response.access_token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            let respo = await res.json();
            window.open(respo.hosted_url, '_BLANK');
        } else {
            swal('warning', 'Something went wrong try after some time', 'warning');
        }

    }

    const getUsdbalance =async(price)=>{
        let NFTPayment =props.prop?.data?.NFT_info?.NFT_payment;
        let from ;
       
        if(NFTPayment=="BNB"){
            from="BNB";
        }else if(NFTPayment=="ETH"){
            from="ETH";
        }else if(NFTPayment=="MATIC"){
            from="MATIC";
        }
        var requestOptions = {
            method: "GET",
            redirect: "follow",
          };
        let ConvertToUSD = await fetch(
            `https://min-api.cryptocompare.com/data/price?fsym=${from}&tsyms=USD`,
            requestOptions,
          );
          ConvertToUSD = await ConvertToUSD.json();
          console.log("usd",ConvertToUSD.USD)
          setprice(Number(ConvertToUSD.USD * price).toFixed(5));
    }

    useEffect(()=>{
        getUsdbalance(props.prop?.data?.NFT_info?.NFT_price);
    },[props.prop?.data?.NFT_info?.NFT_price])
    return (
        <Box>
            {props.prop?.data?.NFT_info?.NFT_resell == 'on' && <Button className='buy_mint' sx={{ color: '#fff', }} onClick={handleOpen}>Buy</Button>}
            <Modal
                open={open} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description" >
                <Box className='checkbox' sx={{ ...style, }}>
                    <Box paddingY='1rem'>
                        <Typography variant='h4' component='h4' id="parent-modal-title">Checkout</Typography>
                    </Box>
                    <Typography id="parent-modal-description">
                        You are about to purchase a <b>{props.prop?.data?.NFT_info?.Private ==0? props.prop?.data?.NFT_info?.NFT_name:"SECRET NFT"}</b>
                    </Typography>
                    <Box paddingY='1rem' className='kajol' display={'flex'} alignItems='center' borderRadius={'5px'} border={{ border: '1px solid #cfcfcf', padding: '10px', fontWeight: 'bold' }}>
                        <Box className='ramkalyan' display={'flex'} alignItems='center' >
                        {props.prop?.data?.NFT_info?.NFT_chainid == Bsc_Chainid ? 
                            <img src={bnb} width={'40px'} />
                            :props.prop?.data?.NFT_info?.NFT_chainid == Matic_Chainid ? 
                            <img src={matic} width={'40px'} />
                            :props.prop?.data?.NFT_info?.NFT_chainid == ETH_Chainid ?       
                            <img src={eth} width={'40px'} />:""}

                            <Typography variant='h5' fontSize={'15px'} display={'inline-block'} marginLeft={'15px'} fontWeight='500' textAlign='left' >
                                {account && account.substring(0, 35)} <br />{props.prop?.data?.NFT_info?.NFT_payment}
                                <Typography textAlign='left' display='block !important'></Typography>
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} marginY='15px'>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label="Pay With Crypto" {...a11yProps(0)} />
                                <Tab label="Pay With Card" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0} className='quantity'>
                            <Box className='decimal'>
                                <Box className='serviced' justifyContent='space-between' display='flex' padding='0px !important'>
                                    <Typography variant='h3' component='h3' fontSize='18px' fontWeight='bold'>
                                        Balance
                                    </Typography>
                                    <Typography variant='h6' component='h6' fontSize='18px' fontWeight='normal'>
                                        {balance && Number(balance).toFixed(5)} {props.prop?.data?.NFT_info?.NFT_payment}
                                    </Typography>
                                </Box>
                                <Box className='serviced' justifyContent='space-between' display='flex' padding='0px !important'>
                                  
                                </Box>
                                <Box className='serviced' justifyContent='space-between' display='flex' padding='0px !important'>
                                    <Typography variant='h3' component='h3' fontSize='18px' fontWeight='bold'>
                                        You Will pay
                                    </Typography>
                                    <Typography variant='h6' component='h6' fontSize='18px' fontWeight='normal'>
                                        {props.prop?.data?.NFT_info?.NFT_price} {props.prop?.data?.NFT_info?.NFT_payment}
                                    </Typography>
                                </Box>
                            </Box>
                        </TabPanel>
                        <TabPanel value={value} index={1} className='quantity'>
                            <Box className='decimal'>
                                {/* <TextField id="outlined-basic" fullWidth variant="outlined" /> */}
                                {/* <Typography variant='h6' fontWeight='normal' fontSize='16px' marginY='10px'>
                                    Enter quantity. <b> 1 available </b>
                                </Typography> */}
                                <Box className='serviced' justifyContent='space-between' display='flex' padding='0px !important'>
                                    <Typography variant='h3' component='h3' fontSize='18px' fontWeight='bold'>
                                        Balance
                                    </Typography>
                                    <Typography variant='h6' component='h6' fontSize='18px' fontWeight='normal'>
                                        {balance && Number(balance).toFixed(4)} {props.prop?.data?.NFT_info?.NFT_payment}
                                    </Typography>
                                </Box>
                                <Box className='serviced' justifyContent='space-between' display='flex' padding='0px !important'>
                                    {/* <Typography variant='h3' fontSize='18px' fontWeight='bold'>
                                        Service Fee 2.5%
                                    </Typography> */}
                                    {/* <Typography variant='h6' fontSize='18px' fontWeight='normal'>
                                        0.8 ETH
                                    </Typography> */}
                                </Box>
                                <Box className='serviced' justifyContent='space-between' display='flex' padding='0px !important'>
                                    <Typography variant='h3' component='h3' fontSize='18px' fontWeight='bold'>
                                        You Will pay
                                    </Typography>
                                    <Typography variant='h6' component='h6' fontSize='18px' fontWeight='normal'>
                                        {Usdvalue} USD
                                    </Typography>
                                </Box>
                            </Box>
                        </TabPanel>
                        <br></br>
                        <Button className='visa' disabled={props.prop?.data?.NFT_info?.NFT_owner_address == account ? true : false} variant="contained" fullWidth onClick={() => paywithcrypto(Usdvalue)}> Add Funds with Visa  </Button>
                        <br></br><br></br>
                        <Button className='visa_card' disabled={props.prop?.data?.NFT_info?.NFT_owner_address == account || Number(props.prop?.data?.NFT_info?.NFT_price) > Number(balance) ? true : false} variant="contained" fullWidth onClick={() => Buynft()}>Buy</Button>

                        {balance < props.prop?.data?.NFT_info?.NFT_price ?
                            <Typography variant='h5' component='h5' fontSize='16px' fontWeight='bold' textAlign='center' paddingTop='10px'>
                                Insufficient Funds
                            </Typography>
                            : ""}
                    </Box>
                    {/* <Checkpopups /> */}
                </Box>
            </Modal>
            {isloading && <Loading props={'Transaction in process, Please wait do not refresh the page...'} />}
        </Box>
    );
}
